const Domain: any = {
  test: 'https://test.genghuo.com/api/video-mall-app',
  dev: 'https://prod.genghuo.com/api/video-mall-app',
  // dev: 'http://192.168.94.72:8080',
  // dev: 'http://192.168.94.199:8080',
  // dev: 'http://192.168.95.7:8088',
  production: 'https://prod.genghuo.com/api/video-mall-app',
  baidu: 'http://api.map.baidu.com' // 百度地API域名
};
// 埋点域名
const LogDomain: any = {
  dev: 'https://test.genghuo.com/api/video-mall-data',
  test: 'https://test.genghuo.com/api/video-mall-data',
  production: 'https://prod.genghuo.com/api/video-mall-data'
};

export default {
  Domain,
  LogDomain
};
